import { useEffect, useState } from "react";
import api from "../api/axiosInstance";

// Dropdown of job titles used in existing optimizations (jobDescription.title).
// Works like a normal <select>: onChange receives the change event, so it
// drops into any form that uses e.target.value.
export default function JobTitleSelect({ value, onChange, name = "technology", allLabel = "All" }) {
  const [titles, setTitles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/optimization/job-titles")
      .then((res) => setTitles(res.data.jobTitles || []))
      .catch((err) => console.error("Failed to load job titles", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <select name={name} value={value || ""} onChange={onChange} disabled={loading}>
      <option value="">{loading ? "Loading…" : allLabel}</option>
      {titles.map((title) => (
        <option key={title} value={title}>
          {title}
        </option>
      ))}
    </select>
  );
}